module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/3_ba302b504b759b6d406927ca267123e6.png";